import React from "react";
import { FloatingDialog } from "../atoms/FloatingDialog";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useTranslation from "../../hooks/useTranslation";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogClearData = ({ visible, onClose, onConfirm, isClearing = false }) => {
  const T = useTranslation();
  
  return (
    <FloatingDialog isOpen={visible} onClose={!isClearing ? onClose : undefined}>
      <div className="flex flex-col w-full h-full items-center justify-center gap-5">
        <div className="rounded flex items-center justify-center text-xl bg-red-500 w-16 h-16 text-white">
          <FontAwesomeIcon icon={faTrash} size="lg" />
        </div>
        <span className="font-bold text-center text-base text-[24px]">
          {isClearing ? T("Limpiando datos...") : T("¿Borrar todos los datos?")}
        </span>
        <span className="text-center text-base text-gray-600 max-w-[400px]">
          {isClearing 
            ? T("Por favor espera mientras se limpian todos los datos de la aplicación.")
            : T("Esta acción borrará todos los informes guardados, configuraciones y datos almacenados en el navegador. No se puede deshacer.")
          }
        </span>
        {!isClearing && (
          <div className="flex flex-wrap justify-center gap-4 w-full max-w-[450px]">
            <SimpleButton 
              onClick={onConfirm} 
              text={T("Borrar todos los datos")} 
              variant="red" 
            />
            <SimpleButton 
              onClick={onClose} 
              text={T("Cancelar")} 
              variant="gray" 
            />
          </div>
        )}
        {isClearing && (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500"></div>
          </div>
        )}
      </div>
    </FloatingDialog>
  );
};

export default DialogClearData;
